import { render } from "./CreateChatModal.vue?vue&type=template&id=2a543102&scoped=true"
import script from "./CreateChatModal.vue?vue&type=script&lang=js"
export * from "./CreateChatModal.vue?vue&type=script&lang=js"

import "./CreateChatModal.vue?vue&type=style&index=0&id=2a543102&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a543102"]])

export default __exports__